var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3D3736",
    strokeLinecap: "round",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m2.78 10.2 3.02 3.02a3.187 3.187 0 0 0 4.5 0l2.927-2.927a3.187 3.187 0 0 0 0-4.5L10.2 2.78a3.17 3.17 0 0 0-2.4-.927l-3.333.16a2.576 2.576 0 0 0-2.46 2.447l-.16 3.333c-.04.9.3 1.774.933 2.407"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.334 8a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333Z"
  }))));
};
export default SvgTag;